<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (alt)="alt()"
  (cancel)="cancel()"
  (confirm)="confirmSelection($event)"
  data-test="import-cropfields-v2"
>
  <div class="flex--row flex--gutter">
    <div class="flex__child--auto spacing--padding-all">
      {{ 'syncCropFieldsExplanation' | translate }}
    </div>
  </div>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title> {{ 'newFields' | translate }} </mat-panel-title>
      <mat-panel-description> {{ selectableNewCropFields.length }} </mat-panel-description>
    </mat-expansion-panel-header>
    <agr-notification-empty
      [isEmpty]="selectableNewCropFields.length === 0"
      [emptyTitle]="'noCropFieldsTitle' | translate"
      [emptyDescription]="'noCropFieldsInCategory' | translate"
    >
      <div class="crop-field-filter--list">
        @for (
          item of getCropNamesFromSelectableCropFieldsWithCropFieldCounts(selectableNewCropFields)
            | keyvalue;
          track item
        ) {
          <div
            matRipple
            class="crop-field-filter--item grey-in-animation"
            (click)="toggleAllCropFieldsWithCropName(item.key, selectableNewCropFields)"
          >
            <span [title]="item.key" class="crop-field-filter--item-title">{{ item.key }}</span>
            <div class="crop-field-filter--item-count">
              <mat-checkbox
                disabled
                class="crop-field-filter--item-checkbox"
                [indeterminate]="
                  partiallyCropFieldsOfCropTypeSelected(
                    item.key,
                    item.value,
                    selectableNewCropFields
                  )
                "
                [checked]="
                  allCropFieldsOfCropTypeSelected(item.key, item.value, selectableNewCropFields)
                "
              >
              </mat-checkbox>
              <span>{{ item.value }}</span>
            </div>
          </div>
        }
      </div>

      <div class="flex--row flex--gutter">
        <mat-action-list class="flex__child--auto">
          @for (cropField of selectableNewCropFields; track cropField; let i = $index) {
            <button
              mat-list-item
              [attr.data-test]="'crop-field--' + i"
              [class.selected-crop-field]="cropField.isSelected"
              (click)="cropField.isSelected = !cropField.isSelected"
            >
              <h2 matListItemTitle>
                {{ cropField.name || 'No Name' }}
              </h2>
              <p matListItemTitle>
                {{ cropField.beginDate | date: 'shortDate' }} -
                {{ cropField.endDate | date: 'shortDate' }}
              </p>
              <p matListItemTitle>{{ cropField.hectares || 0 }} ha</p>
              <p matListItemTitle>
                {{ cropField.cropName || 'Unknown Crop' }}
                {{ cropField.cropVarietyName ? ' (' + cropField.cropVarietyName + ')' : '' }}
              </p>
              @if (cropField.isSubsequentCultivation) {
                <p matListItemTitle class="subsequent-cultivation">
                  {{ 'subsequentCultivation' | translate }}
                </p>
              }
            </button>
          }
        </mat-action-list>
      </div>
    </agr-notification-empty>
  </mat-expansion-panel>

  <div class="spacing--margin-vertical">
    <mat-expansion-panel class="spacing--margin-vertical">
      <mat-expansion-panel-header>
        <mat-panel-title> {{ 'existingFields' | translate }} </mat-panel-title>
        <mat-panel-description> {{ selectableChangedCropFields.length }} </mat-panel-description>
      </mat-expansion-panel-header>
      <agr-notification-empty
        [isEmpty]="selectableChangedCropFields.length === 0"
        [emptyTitle]="'noCropFieldsTitle' | translate"
        [emptyDescription]="'noCropFieldsInCategory' | translate"
      >
        <div class="crop-field-filter--list">
          @for (
            item of getCropNamesFromSelectableCropFieldsWithCropFieldCounts(
              selectableChangedCropFields
            ) | keyvalue;
            track item
          ) {
            <div
              matRipple
              class="crop-field-filter--item grey-in-animation"
              (click)="toggleAllCropFieldsWithCropName(item.key, selectableChangedCropFields)"
            >
              <span [title]="item.key" class="crop-field-filter--item-title">{{ item.key }}</span>
              <div class="crop-field-filter--item-count">
                <span>{{ item.value }}</span>
              </div>
            </div>
          }
        </div>

        <div class="flex--row flex--gutter">
          <mat-action-list class="flex__child--auto">
            <div class="flex--row">
              <div class="flex__child--1">
                <div class="current-values-title">
                  <h2>{{ 'currentValues' | translate }}</h2>
                </div>
              </div>
              <div class="flex__child--1">
                <h2>{{ 'newValues' | translate }}</h2>
              </div>
            </div>
            @for (cropField of selectableChangedCropFields; track cropField; let i = $index) {
              <button
                mat-list-item
                [attr.data-test]="'crop-field--' + i"
                [class.selected-crop-field]="cropField.isSelected"
                (click)="cropField.isSelected = !cropField.isSelected"
              >
                <div class="flex--row flex--nowrap">
                  <div class="flex__child--1 spacing--margin-right">
                    <h2 matListItemTitle>
                      {{ cropField.existing.name || 'No Name' }}
                    </h2>
                    <p matListItemTitle>
                      {{ (cropField.existing.hectares | number: '0.0-2') || 0 }} ha
                    </p>
                    <p matListItemTitle>
                      {{ cropField.existing.cropName || 'Unknown Crop' }}
                      {{
                        cropField.existing.cropVarietyName
                          ? ' (' + cropField.existing.cropVarietyName + ')'
                          : ''
                      }}
                    </p>
                  </div>
                  <div class="flex__child--1">
                    <h2 matListItemTitle>
                      {{ cropField.external.name || 'No Name' }}
                    </h2>
                    <p matListItemTitle>
                      {{ cropField.external.beginDate | date: 'shortDate' }} -
                      {{ cropField.external.endDate | date: 'shortDate' }}
                    </p>
                    <p matListItemTitle>
                      {{ (cropField.external.hectares | number: '0.0-2') || 0 }} ha
                    </p>
                    <p matListItemTitle>
                      {{ cropField.external.cropName || 'Unknown Crop' }}
                      {{
                        cropField.external.cropVarietyName
                          ? ' (' + cropField.external.cropVarietyName + ')'
                          : ''
                      }}
                    </p>
                    @if (cropField.external.isSubsequentCultivation) {
                      <p matListItemTitle class="subsequent-cultivation">
                        {{ 'subsequentCultivation' | translate }}
                      </p>
                    }
                  </div>
                </div>
              </button>
            }
          </mat-action-list>
        </div>
      </agr-notification-empty>
    </mat-expansion-panel>
  </div>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ 'notPresentIn' | translate }} {{ providerName(data.externalCropFieldSource) }}
      </mat-panel-title>
      <mat-panel-description> {{ selectableDeletedCropFields.length }} </mat-panel-description>
    </mat-expansion-panel-header>
    <agr-notification-empty
      [isEmpty]="selectableDeletedCropFields.length === 0"
      [emptyTitle]="'noCropFieldsTitle' | translate"
      [emptyDescription]="'noCropFieldsInCategory' | translate"
    >
      <div class="crop-field-filter--list">
        @for (
          item of getCropNamesFromSelectableCropFieldsWithCropFieldCounts(
            selectableDeletedCropFields
          ) | keyvalue;
          track item
        ) {
          <div
            matRipple
            class="crop-field-filter--item grey-in-animation"
            (click)="toggleAllCropFieldsWithCropName(item.key, selectableDeletedCropFields)"
          >
            <span [title]="item.key" class="crop-field-filter--item-title">{{ item.key }}</span>
            <div class="crop-field-filter--item-count">
              <span>{{ item.value }}</span>
            </div>
          </div>
        }
      </div>

      <div class="flex--row flex--gutter">
        <mat-action-list class="flex__child--auto">
          @for (cropField of selectableDeletedCropFields; track cropField; let i = $index) {
            <button
              mat-list-item
              [attr.data-test]="'crop-field--' + i"
              [class.selected-crop-field]="cropField.isSelected"
              (click)="cropField.isSelected = !cropField.isSelected"
            >
              <h2 matListItemTitle>
                {{ cropField.name || 'No Name' }}
              </h2>
              <p matListItemTitle>{{ cropField.hectares || 0 }} ha</p>
              <p matListItemTitle>
                {{ cropField.cropName || 'Unknown Crop' }}
                {{ cropField.cropVarietyName ? ' (' + cropField.cropVarietyName + ')' : '' }}
              </p>
            </button>
          }
        </mat-action-list>
      </div>
    </agr-notification-empty>
  </mat-expansion-panel>
</agr-form-dialog>
